<template>
  <div class="row text-center">
    <button class="btn-orange" @click="$emit('next')">Continue</button><br>
    <button v-if="!skip" class="btn-back mt-2" @click="$emit('prev')">Back</button>
    <button v-else class="btn-skip mt-2" @click="$emit('skip')">Skip</button>
  </div>
</template>

<script>
export default {
  name: "StepsNavigationButtons",
  props: {
    skip: {
      type: Boolean,
      default: false
    },
  },
}
</script>